<template>
    <div>
        <h3>Learning Statistics for {{ getTenantCourse.title }}</h3>
        <!-- <h1 class="text-h1 mb-6 ml-8"> Course Stats</h1> -->
        
        <div class="container mx-auto px-4 sm:px-8">
        <div class="py-8">
            
            <div class="my-1">
                <div class="flex justify-between items-center">
                    
                    <div class="relative">
                        <select
                            v-model="search"
                            class="appearance-none h-full w-56 rounded-r  sm:rounded-r-none block appearance-none bg-white border-gray-400 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:border-l focus:border-r focus:bg-white focus:border-gray-500">
                            <option >Filter</option>
                            <option value="started">Learning</option>
                            <option value="completed">Completed</option>
                        </select>
                        <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                        </div>
                    </div>

                    <div>
                        <download-csv
                        class="custom_support-color text-white py-3 px-6 rounded cursor-pointer"
                        name="lms.csv"
                        :data   = "jsonCsv">
                            Download as CSV
                        </download-csv>
                    </div>
                    
                </div>
                
            </div>
            
            <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-2 overflow-x-auto">
                <!-- <div class="w-48 ml-auto">
                    <download-csv
                    class="custom_support-color text-white py-3 px-6 rounded cursor-pointer"
                    name="lms.csv"
                    :data   = "jsonCsv">
                        Download as CSV
                    </download-csv>
                </div> -->
                <div class="inline-block min-w-full shadow rounded-lg overflow-hidden" v-if="filterStat.length > 0">
                    <table class="min-w-full leading-normal">
                        <thead>
                            <tr>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    S/N
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Name
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Email
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Status
                                </th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(stat,index) in filterStat" :key="stat.id">
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                    <div class="flex items-center">
                                        <!-- <div class="flex-shrink-0 w-10 h-10">
                                            <img class="w-full h-full rounded-full"
                                                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.2&w=160&h=160&q=80"
                                                alt="" />
                                        </div> -->
                                        <div class="ml-3">
                                            <p class="text-gray-900 whitespace-no-wrap">
                                                {{ index+1 }}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td  v-if="stat.user !== null" class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                    <p class="text-gray-900 whitespace-no-wrap">{{ stat.user.first_name + ' '+ stat.user.last_name }}</p>
                                </td>
                                <td v-if="stat.user !== null" class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                    <p  class="text-gray-900 whitespace-no-wrap">
                                        {{ stat.user.email }}
                                    </p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                    <span
                                        class="relative inline-block px-3 py-1 font-semibold  leading-tight" :class="{'text-green-900': stat.progress >= 100, 'text-blue-900': stat.progress > 0 && stat.progress < 100, }">
                                        <span aria-hidden
                                            class="absolute inset-0 opacity-50 rounded-full" :class="{' bg-green-200': stat.progress >= 100, ' bg-blue-200': stat.progress > 0 && stat.progress < 100, }"></span>
                                        <span class="relative">{{ stat.progress >= 100 ? 'Completed' : 'Learning'}}</span>
                                    </span>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                    <div class="my-3">
                        <paginate
                            :page-count="getpageCount"
                            :click-handler="callbackHandler"
                            :prev-text="'Prev'"
                            :next-text="'Next'"
                            class="pagination">
                        </paginate>
                    </div>
                    <!-- <div
                        class="px-5 py-5 bg-white border-t flex flex-col xs:flex-row items-center xs:justify-between          ">
                        <span class="text-xs xs:text-sm text-gray-900">
                            Showing {{ current_page}} to {{ per_page }} of {{ total_page }} Entries
                        </span>
                        <div class="inline-flex mt-2 xs:mt-0">
                            <button
                                class="text-sm bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-l"
                                :disabled="!prev_page" @click="getStat(current_page-1)"
                                >
                                Prev
                            </button>
                            <button
                                class="text-sm bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-r"
                                :disabled="!next_page" @click="getStat( current_page+1)"
                                >
                                Next
                            </button>
                        </div>
                    </div> -->
                </div>
                <div class="h-64 flex items-center justify-center bg-white rounded " v-else>
                    No data
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapActions,mapMutations, mapGetters } from "vuex";

    export default {
        name:'tenant-course-stats',
        components: {
        },
        data () {
            return {
                stats: [],
                jsonCsv:[],
                search:'Filter',
                current_page:1,
                last_page:'',
                prev_page:'',
                next_page:'',
                total_page:0,
                per_page:100
            }
        },
        computed:{
            ...mapGetters(["getTenantCourse"]),
            getpageCount:function() {
                return Math.ceil(this.stats.length / this.per_page);
            },
            filterStat:function(){
                let data = this.stats.filter((item) => {
                    if(this.search === 'started'){
                        return item.progress < 100;
                    }else if( this.search === 'completed'){
                        return item.progress >= 100;
                    } else {
                        return item;
                    }
                    
                });
                let current = this.per_page * this.current_page;
                let start = current - this.per_page;
                return data.slice(start,current);
            }
        },
        methods:{
            ...mapActions(["getOverallStats"]),
            ...mapMutations(["updateLoader"]),
            async getStat(page = 1){
                // console.log(this.current_page)
                this.updateLoader(true)
                try {
                    const res = await this.getOverallStats({
                        id: this.$route.params.id,
                        page:page
                    });
                    if(res.status === 200){
                        this.stats = res.data;
                        
                        let data = res.data.map((e)=> {
                            return {
                                name: e.user.first_name + ' ' + e.user.last_name,
                                email: e.user.email,
                                phone_number: e.user.phone_number
                            };
                        })
                        console.log(data)
                        // console.log(data)
                        this.jsonCsv = data;
                    }
                    // console.log(res.data)
                    
                    this.updateLoader(false)
                } catch(e) {
                    this.$Bus.$emit("notify", {
                        type: "error",
                        message: 'Something Went Wrong Trying To Fetch Courses stat',
                    });
                    this.updateLoader(false)
                }
            },
            callbackHandler(pageNum){
                this.current_page = Number(pageNum);
            }
        },
        async mounted() {
            this.getStat();
        },
    }
</script>

<style>
.custom_support-color{
    background-color: #2E3A6E;
}
.pagination a {
    float: left;
    padding: 4px 8px;
    text-decoration: none;
    border: 1px solid #ddd;
    background-color: #6b6b79;
}

.pagination .active a {
    background-color: grey;
}
.pagination .disabled a {
    background-color: #1F2D3D;
}

.pagination  a:hover:not(.active) {
    background-color: grey;
}

.pagination   a:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.pagination a:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}
.pagination li {
    float: left;
    padding: 4px 8px;
    text-decoration: none;
    border: 1px solid #ddd;
    color: white;
    background-color: white;
    font-size: 1em;
}

.pagination  li:hover:not(.active) {
    background-color: #1c2331;
    color: #ffffff;
}
.pagination  li .active{
    background-color: #8e9aa8;
    color: #f0f4c3;
}
</style>